type HapticsPlugin = { impact?: (options: { style: string }) => Promise<void> };
type Host = { Capacitor?: { Plugins?: { Haptics?: HapticsPlugin } } };

/**
 * A light tick, as when a long press opens a menu. The phone apps use the system haptics. Android
 * browsers vibrate briefly. Elsewhere it does nothing.
 */
export function hapticTick(host: Host = globalThis as Host): void {
  const haptics = host.Capacitor?.Plugins?.Haptics;
  if (haptics?.impact) {
    void haptics.impact({ style: "LIGHT" }).catch(() => undefined);
    return;
  }
  try {
    navigator.vibrate?.(8);
  } catch {
    // Some browsers refuse to vibrate before the first tap. The menu still opens.
  }
}
